import { render } from "./regularList.vue?vue&type=template&id=c5b2a410&scoped=true"
import script from "./regularList.vue?vue&type=script&lang=js"
export * from "./regularList.vue?vue&type=script&lang=js"

import "./regularList.vue?vue&type=style&index=0&id=c5b2a410&lang=scss&scoped=true"
import "./regularList.vue?vue&type=style&index=1&id=c5b2a410&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5b2a410"]])

export default __exports__